function r(o){if(typeof o!="object"||o===null)return!1;let e=Object.getPrototypeOf(o);return e===null||e===Object.prototype}export{r as a};
